import Vue from 'vue'

const vm = Vue.observable({
  count: 0,
})

export const spinner = {
  start() {
    vm.count++
  },
  stop() {
    vm.count--
  },
  get loading() {
    return vm.count > 0
  },
}
